import { IconName } from '@usealloy/component-library';

export interface EntityGroupRelationship {
  entity_token: string;
  name: string;
  title?: string;
  type: 'person' | 'business';
  ownership_percentage?: number;
  roles: string[];
  relationship_created_at: string;
  bank_accounts: any[];
}

export interface EntityGroupData {
  created_at: string;
  entity_group_token: string;
  entity_group_name: string;
  entity_group_type: string;
  entity_group_relationships: EntityGroupRelationship[];
  entity_group_external_identifiers: string[];
}

export const ENTITY_TYPES = {
  person: 'person',
  business: 'business',
  group: 'group',
  entity_group: 'entity_group',
} as const;

export type EntityType = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];

export const ENTITY_ICON_MAP: Record<EntityType, IconName> = {
  [ENTITY_TYPES.person]: IconName.Person,
  [ENTITY_TYPES.business]: IconName.Business,
  [ENTITY_TYPES.group]: IconName.Group,
  [ENTITY_TYPES.entity_group]: IconName.CustomGroup,
};

export const TOOLTIP_TEXT: Record<EntityType, string> = {
  person: 'Person',
  business: 'Business',
  group: 'Group',
  entity_group: 'Entity Group',
};

